/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, Button, Box, Flex } from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import { useTranslation } from 'react-i18next';
import { getDepartment, getDepartmentOffices, getDepartments, getOffice } from '../../../utils/departmentOfficeSelectionWrapper';
import TextFormField from '../../../components/form/TextFormField';
import CheckMarkFormField from '../../../components/form/CheckMarkFormField';
import SelectSearchFormField from '../../../components/form/SelectSearchFormField';
import TagInputField from '../../../components/form/TagInputField';
import useStore from '../../../store';
import c from '../../../constant';
import * as Yup from 'yup';
import 'moment/locale/en-gb';

function Filter({
	step = '',
	number = '',
	subject = '',
	department = null,
	office = null,
	unread = false,
	tags = null,
	more = false,
	onCallback = () => null,
	onClose = () => null,
}) {
	const { t } = useTranslation();
	const { currentLang: lang } = useStore((state) => state.currentLang);
	const validationSchema = useMemo(
		() =>
			Yup.object().shape({
				number: Yup.string().nullable(),
				subject: Yup.string().nullable(),
				department: Yup.object().nullable(),
				office: Yup.object().nullable(),
				tags: Yup.array().of(Yup.string().required('required')).min(0),
				unread: Yup.boolean(),
			}),
		[]
	);

	return (
		<>
			<Modal borderRadius={c.borderRadius} isOpen={true} onClose={onClose}>
				<ModalOverlay />
				<ModalContent borderRadius={c.borderRadius}>
					<ModalHeader>{t('Filter')}</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Formik
							initialValues={{
								number: number || '',
								subject: subject || '',
								department: getDepartment(department, lang),
								office: getOffice(department, office, lang),
								tags,
								unread,
							}}
							validationSchema={validationSchema}
							onSubmit={(values) => {
								let url = '?page=1';
								if (step) {
									url += '&step=' + step;
								}
								if (values?.number) {
									url += '&number=' + values?.number;
								}
								if (values?.subject) {
									url += '&subject=' + values?.subject;
								}
								if (values?.department?.value) {
									url += '&department=' + values?.department?.value;
								}
								if (values?.office?.value) {
									url += '&office=' + values?.office?.value;
								}
								if (values?.tags?.length > 0) {
									url += '&tags=' + encodeURIComponent(JSON.stringify(values?.tags));
								}
								if (values?.unread) {
									url += '&unread=' + values?.unread;
								}
								if (more) {
									url += '&more=' + more;
								}
								onCallback(url);
								onClose();
							}}
						>
							{({ values, ...props }) => {
								return (
									<Box pb="4">
										<Form>
											<TextFormField {...props} label="Number" name="number" />
											<TextFormField {...props} label="Subject" name="subject" />
											<SelectSearchFormField
												{...props}
												name="department"
												label="Department"
												placeholder="Department"
												options={getDepartments(lang)}
												callback={(e) => props?.setFieldValue('office', null)}
											/>
											{values?.department && (
												<>
													<SelectSearchFormField
														{...props}
														name="office"
														label="Office"
														placeholder="Office"
														options={getDepartmentOffices(values?.department?.value, lang)}
													/>
												</>
											)}
											<TagInputField name="tags" label="Tag" />
											<Box marginTop="4">
												<CheckMarkFormField {...props} label="Show unread only" name="unread" />
											</Box>
											<Flex mt="32px" justifyContent="flex-end">
												<Button
													variant="ghost"
													size="md"
													h="42px"
													w="128px"
													onClick={() => {
														let url = '?page=1';
														if (step) {
															url += '&step=' + step;
														}
														if (more) {
															url += '&more=' + more;
														}
														onCallback(url);
														onClose();
													}}
												>
													{t('Clear')}
												</Button>
												<Button
													ml={4}
													variant="solid"
													size="md"
													h="42px"
													w="128px"
													type="submit"
													borderRadius={c.borderRadius}
													color="#3498db"
												>
													{t('Apply')}
												</Button>
											</Flex>
										</Form>
									</Box>
								);
							}}
						</Formik>
					</ModalBody>
				</ModalContent>
			</Modal>
		</>
	);
}

export default Filter;
